module.exports = __webpack_public_path__ + "static/media/moneymix.2396774b.png";